<template>
  <div class="tenant__list">
    <h3>Tenants</h3>
    <ul>
      <li v-for="item in items" :key="item.id" @click="selectItem(item)">
        {{ item.name }}
        <button
          @click.stop="deleteItem(item)"
          style="float: right"
          :disabled="!user"
          :title="!user ? 'Please login to delete a tenant' : 'Delete'"
          class="button is-danger is-rounded action-button"
          icon-left="plus"
        >
          Delete
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "list",
  props: {
    items: {
      type: Array
    }
  },
  computed: {
    ...mapGetters(["user"])
  },
  methods: {
    selectItem(item) {
      this.$emit("selectItem", item);
    },
    deleteItem(item) {
      this.$emit("deleteItem", item);
    }
  }
};
</script>
